import React from "react";
import { useGameState } from "context/GameContext";
// Css
import classes from "./Code.module.scss";

const Code: React.FC = () => {
  const { code } = useGameState();

  return (
    <div className={classes.container}>
      <strong>
        <span>Game code: </span>
        <span>{code}</span>
      </strong>
    </div>
  );
};

export default Code;
